import * as types from "./types";

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function itemAddedListaAlumnos(payload) {
  return { type: types.ITEM_ADDED, payload };
}

function itemRemovedListaAlumnos(payload) {
  return { type: types.ITEM_REMOVED, payload };
}

function obtenerDetalleAlumno(payload) {
  return { type: types.FETCH_DETALLE, payload };
}

function resetListaAlumnos() {
  return { type: types.RESET };
}

function resetDetalleAlumno() {
  return { type: types.RESET_DETALLE };
}

/*---*/
export {
  dataSaved,
  resetDataSaved,
  itemAddedListaAlumnos,
  itemRemovedListaAlumnos,
  resetListaAlumnos,
  obtenerDetalleAlumno,
  resetDetalleAlumno
};



// WEBPACK FOOTER //
// ./src/ducks/alumnos/actions.js